import { Reveal, Overline } from "@/components/Reveal";
import { GraduationCap, Landmark } from "lucide-react";

const CEL_ITEMS = [
  ["Programas CEL", "Cursos, talleres y certificaciones profesionales para el mercado ejecutivo."],
  ["Future Leaders", "Programa de liderazgo para jóvenes de 14 a 18 años, centrado en habilidades del siglo XXI e inteligencia artificial. La generación que está formando su forma de pensar, hoy."],
  ["Programas de inglés", "Formación en el idioma que abre puertas profesionales en toda la región."],
  ["Insignias digitales", "Credenciales verificables que certifican competencias específicas en marketing, coaching y desarrollo profesional y personal. La forma moderna de demostrar lo que se sabe hacer."],
  ["Diplomados ejecutivos", "Especialización de mediana duración para perfiles que buscan avanzar en su carrera."],
  ["Especializaciones profesionales", "Profundización estratégica en las áreas que más está pidiendo el mercado."],
];

const OFFICIAL = [
  ["Florida Global University (FGU)", "Licenciaturas, maestrías y doctorados con reconocimiento internacional.", "https://customer-assets.emergentagent.com/job_kairos-latam-hub/artifacts/0crxq4fz_logo_fgu_web.png"],
  ["Universidad UTBP", "Licenciaturas, maestrías y doctorados con validez oficial en México y Latinoamérica.", "https://customer-assets.emergentagent.com/job_kairos-latam-hub/artifacts/gcjczxyr_Copia%20de%20Disen%CC%83o%20sin%20ti%CC%81tulo%20%284%29.png"],
  ["American Elite School (AES)", "Dual Diploma: doble titulación con proyección internacional.", "https://customer-assets.emergentagent.com/job_kairos-latam-hub/artifacts/zqul8fl7_logo_AES.png"],
];

export function ProductLines() {
  return (
    <section id="productos" data-testid="productos-section" className="relative py-24 sm:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <Reveal className="max-w-3xl">
          <Overline>Líneas de producto</Overline>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-midnight mt-6 leading-[1.1]">
            Cuatro formas de generar ingresos bajo una sola marca.
          </h2>
        </Reveal>

        {/* Educación continua */}
        <div className="mt-16">
          <Reveal>
            <div className="flex items-center gap-3">
              <GraduationCap className="w-6 h-6 text-crimson" />
              <h3 className="font-serif text-2xl sm:text-3xl font-semibold text-midnight">Educación continua</h3>
            </div>
            <p className="font-sans text-base font-light text-midnight/70 mt-3 max-w-3xl">
              El corazón operativo del catálogo, desarrollado bajo la estructura académica del Center of Education and
              Leadership (CEL). Programas de corta y mediana duración, pensados para formar, certificar y generar ingresos recurrentes.
            </p>
          </Reveal>

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-midnight/10 border border-midnight/10 mt-8">
            {CEL_ITEMS.map(([title, desc], i) => (
              <Reveal key={title} delay={(i % 3) * 0.08} className="bg-white">
                <div className="p-7 h-full">
                  <div className="font-serif text-xs text-crimson font-bold tabular-nums">{String(i + 1).padStart(2, "0")}</div>
                  <h4 className="font-serif text-xl font-semibold text-midnight mt-3">{title}</h4>
                  <p className="font-sans text-sm font-light text-midnight/60 mt-2 leading-relaxed">{desc}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>

        {/* Programas académicos oficiales */}
        <div className="mt-20">
          <Reveal>
            <div className="flex items-center gap-3">
              <Landmark className="w-6 h-6 text-crimson" />
              <h3 className="font-serif text-2xl sm:text-3xl font-semibold text-midnight">Programas académicos oficiales</h3>
            </div>
            <p className="font-sans text-base font-light text-midnight/70 mt-3 max-w-3xl">
              Aquí es donde Kairós Learning se distingue de cualquier otra oportunidad de franquicia educativa: acceso a
              programas con validez universitaria oficial, respaldados por instituciones con convenios vigentes.
            </p>
          </Reveal>

          <div className="grid md:grid-cols-3 gap-px bg-midnight mt-8 border border-midnight">
            {OFFICIAL.map(([title, desc, logo], i) => (
              <Reveal key={title} delay={i * 0.1} className="bg-midnight">
                <div className="p-8 h-full flex flex-col">
                  <div className="h-16 flex items-center">
                    <img src={logo} alt={title} className="max-h-14 w-auto max-w-[75%] object-contain" />
                  </div>
                  <div className="w-10 h-px bg-crimson my-5" />
                  <h4 className="font-serif text-xl font-semibold text-ivory">{title}</h4>
                  <p className="font-sans text-sm font-light text-ivory/70 mt-3 leading-relaxed">{desc}</p>
                </div>
              </Reveal>
            ))}
          </div>

          <Reveal delay={0.1}>
            <p className="font-sans text-base font-light text-midnight/70 mt-8 max-w-3xl border-l-2 border-crimson pl-5">
              Un franquiciatario de Kairós Learning no solo vende cursos. Abre la puerta a que las personas de su
              territorio accedan a educación superior con respaldo institucional real.
            </p>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
